import React from 'react';
import LegalDocumentBody from '../LegalDocumentBody';

type Props = {
    setActiveRightTab?: Function;
};

export default function PrivacyPolicy({ setActiveRightTab }: Props) {
    return <LegalDocumentBody titleKey="privacy-policy" bodyKey="privacy-policy-body" setActiveRightTab={setActiveRightTab} />;
}
